import { startOfDay, startOfMonth, startOfWeek } from 'date-fns';

export function snapStartDateToCalendarBoundary(startDate: Date, days: number): Date {
    if (days < 7) {
        return startOfDay(startDate);
    }

    if (days < 30) {
        return startOfWeek(startDate, { weekStartsOn: 1 });
    }

    return startOfMonth(startDate);
}
